import { Component } from '@angular/core';
import { iBisBaseComponent, iBisLanguageService, iBisUIService } from '@dohu/ibis-common';
import { DataService } from '../../../services';
import { PartyEditService } from './party-edit.service';

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
  selector: 'app-party-edit',
  templateUrl: './party-edit.component.html'
})
export class PartyEditComponent extends iBisBaseComponent {

  constructor(public override edit: PartyEditService, lg: iBisLanguageService, iui: iBisUIService, public ds: DataService) {
    super(edit, lg, iui, null as any);
  }

  onEmailFocusOut = (ev: any) => {
    const value: string = ev.component.option('value');
    if (!value) {
      return;
    }
    const normalized = value.split(',').map((part: string) => part.trim()).filter((part: string) => part.length > 0).join(', ');
    this.edit.model.emailAddress = normalized;
    ev.component.option('value', normalized);
  }

  validateEmailAddress = (ev: { value: string }) => {
    if (!ev.value) {
      return true;
    }
    return ev.value.split(',').every((part: string) => EMAIL_REGEX.test(part.trim()));
  }

}
